import React from "react";
import ServiceRow from "./ServiceRow";

const ServiceTable = ({
  services,
  onAddServiceClick,
  onToggleStatus,
  onDelete,
  rowOffset = 0,
}) => {
  return (
    <>
      <div className="mb-6 flex items-center justify-between gap-4">
        <div>
          <h3 className="text-2xl font-bold text-navy-700 dark:text-white">Available Services</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            Manage services and their associated products
          </p>
        </div>

        <button
          onClick={onAddServiceClick}
          className="px-4 py-2 bg-brand-500 hover:bg-brand-600 text-white rounded-lg font-semibold transition shadow-md hover:shadow-lg"
          title="Add a new Service"
        >
          + Add Service
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200 dark:border-white/10">
              <th className="py-4 px-4 text-left text-sm font-bold text-navy-700 dark:text-white">SNO</th>
              <th className="py-4 px-4 text-left text-sm font-bold text-navy-700 dark:text-white">Service Name</th>
              <th className="py-4 px-4 text-left text-sm font-bold text-navy-700 dark:text-white">Products Count</th>
              <th className="py-4 px-4 text-left text-sm font-bold text-navy-700 dark:text-white">Status</th>
              <th className="py-4 px-4 text-left text-sm font-bold text-navy-700 dark:text-white">Actions</th>
            </tr>
          </thead>
          <tbody>
            {services.map((service, index) => (
              <ServiceRow
                key={service.id}
                index={rowOffset + index}
                service={service}
                onToggleStatus={onToggleStatus}
                onDelete={(svc) => onDelete(svc)}
              />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ServiceTable;